import { makeStyles } from '@material-ui/core';
const drawerWidth = 300;
export const drawerStyles = makeStyles((theme) => ({
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    [theme.breakpoints.up('xs')]: {
      width: theme.spacing(8),
    },
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 21px',
    ...theme.mixins.toolbar,
  },
  nested: {
    paddingLeft: theme.spacing(1),
  },
  text: {
    color: '#6200ee',
    fontSize: '20px',
    fontWeight: 'bold',
  },
  logo: {
    paddingTop: '7vh',
    paddingBottom: '7vh',
    paddingLeft: '3vw',
  },
  logoClose: {
    paddingTop: '7vh',
    paddingBottom: '7vh',
    paddingLeft: '0vw',
  },
  selected: {
    backgroundColor: '#7f39fb',
    color: '#666666',
    '&:hover': {
      backgroundColor: '#f7f0ff',
      color: '#666666',
    },
  },
}));

export const useStyles = makeStyles({
  root: {
    '&$selected': {
      backgroundColor: '#f7f0ff',
      color: '#666666',
      '&:hover': {
        backgroundColor: '#f7f0ff',
        color: '#666666',
      },
    },
  },
  selected: {},
});
